var map = {
	"./favicon.ico": 61191,
	"./logo-full.png": 61748,
	"./logo-itinerary.png": 93596,
	"./logo-voucher.png": 69993,
	"./logo-white.png": 74444,
	"./logo.png": 99068
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 65016;
module.exports = webpackAsyncContext;